import React from 'react';

import Menu from '../Menu/Menu';
import styles from './SquareBlock.module.less';

const SquareBlock: React.FC = () => {
  return (
    <div className={`${styles.squareBlock} ${styles.clickable}`}>
      <Menu />
    </div>
  );
};

export default SquareBlock;
